import { render, staticRenderFns } from "./autologout.vue?vue&type=template&id=09653c68&"
import script from "./autologout.vue?vue&type=script&lang=js&"
export * from "./autologout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09653c68')) {
      api.createRecord('09653c68', component.options)
    } else {
      api.reload('09653c68', component.options)
    }
    module.hot.accept("./autologout.vue?vue&type=template&id=09653c68&", function () {
      api.rerender('09653c68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/alf/autologout.vue"
export default component.exports